import { HttpErrorResponse } from '@angular/common/http';
import { UiLabel } from 'hx-services';

/** The text of a label in the language of the screen; a missing language falls back to the Russian one, then to any language that has a text. */
export function labelText(lang: string, label?: UiLabel | null): string {
  if (!label) {
    return '';
  }
  const own = lang === 'kk' ? label.kk : lang === 'en' ? label.en : label.ru;
  return own || label.ru || label.kk || label.en || label.uz || label.tg || '';
}

/** The languages that have a text, for the small grey line under a name: `ru, kk, en`. */
export function labelLangs(label?: UiLabel | null): string {
  if (!label) {
    return '';
  }
  return (Object.keys(label) as (keyof UiLabel)[]).filter(lang => !!label[lang]).join(', ');
}

/** A business error of the catalog: `HTTP 570 {message: 'catalog.*', data}`; `key` is empty when the answer is not one of them. */
export interface CatalogError {
  key: string;
  data?: Record<string, unknown>;
  status: number;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function catalogErrorOf(err: unknown): CatalogError | null {
  if (!(err instanceof HttpErrorResponse)) {
    return null;
  }
  const body: unknown = err.error;
  const message = isRecord(body) && typeof body['message'] === 'string' ? body['message'] : '';
  const data = isRecord(body) && isRecord(body['data']) ? body['data'] : undefined;
  return {key: message, data, status: err.status};
}

/** `#RRGGBB` — the only colour format the dictionary of labels keeps (the site paints a label with it). */
export const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

/** A code of a label is the tag of a card: lower case latin letters, digits, `_` and `-`, up to 30 signs (the width of `tags_`). */
export const LABEL_CODE = /^[a-z0-9][a-z0-9_-]{0,29}$/;

/** An address of a section: latin words with single dashes (the backend checks the same and the free/taken state). */
export const SECTION_SLUG = /^[a-z0-9]+(-[a-z0-9]+)*$/;
